goog.provide('el8.appchart.dialog.ordermed.util');

goog.require('el8.service.tz');
goog.require('el8.util.string');

el8.appchart.dialog.ordermed.util = (function() {
    return {

        hideDiv: function($div) {
            if ($div) { $div.hide(); $('input', $div).hide(); }
        },

        showDiv: function($div) {
            if ($div) { $div.show(); $('input', $div).show(); }
        },

        parseMedication: function(row) {
            if (!row) { return false; }
            return {'data' : row,
                    'id' : row.id,
                    'value': row.clean_name,
                    'result' : row.clean_name,
                    'score' : row.score
            };
        },

        displayMed: function(name, strength) {
            return (name + ' ' + strength).trim();
        },

        extractPrescriberInfo: function(searchField, infoField) {

            var result = {};
            var isSelfPrescribed = false;
            var prescribingPhysicianId, prescriberName;

            prescribingPhysicianId = searchField ? searchField.getItemId() : null;
            if (!prescribingPhysicianId) { // if we have an ID, getItemVal() will return that ID too
                prescriberName = searchField ? searchField.getItemVal() : '';
                 // cast to string in case an ID somehow slipped through
                prescriberName = prescriberName ? String(prescriberName).trim() : '';
            }

            if (!prescribingPhysicianId) {
                if (prescriberName.toLowerCase() === 'me') {
                    if (el8.data.currUser.isPhysician()) {
                        prescribingPhysicianId = el8.data.currUser.getStaffId();
                    }
                } else {
                    if (prescriberName.toLowerCase() === 'patient' ||
                            prescriberName.toLowerCase() === 'self') {
                        isSelfPrescribed = true;
                    }
                    result['prescriberName'] = prescriberName;
                }
            }

            result['prescribingPhysicianId'] = prescribingPhysicianId;
            result['isSelfPrescribed'] = isSelfPrescribed;
            return result;
        },

        initPatientVitalsPanel: function($container, $contentArea) {
            if (el8.ptdata.currPatient._age >= 18) {
                $container.hide();
                return function () {
                    var noOp = $.Deferred();
                    noOp.resolve();
                    return noOp.promise();
                };
            }

            function updateVitalsDisplay() {
                if ($contentArea.html() === '') {
                    $contentArea.html('<div class="el8ShortLoading"></div>');
                }

                if ($contentArea.is(":visible")) {
                    // Continuously poll the server every 5 min while the vitals are being displayed,
                    // in case they are updated by another user (e.g. nurse inputting vitals from
                    // a nursing station)
                    window.setTimeout(updateVitalsDisplay, 300000);
                }

                return $.el8_ajax({
                    url: el8.service.urls.get('latestVitals', ['weight', 'height'])
                }).done(
                    function(vitals) {
                        var weightDisplayStr, heightDisplayStr;
                        weightDisplayStr = heightDisplayStr = "Not Documented";
                        if (vitals.weight) {
                            var weightStr = el8.util.string.cleanWeight(vitals.weight.weight + vitals.weight.units).displayMetric;
                            var weightDateStr = el8.service.tz.soyDate(vitals.weight.recordDate);
                            weightDisplayStr = weightStr + " (" + weightDateStr + ")";
                        }
                        if (vitals.height) {
                            if (vitals.height.units === 'in') {
                                var heightStr = (Number(vitals.height.height) * 2.54).toFixed(2) + ' cm';
                            } else {
                                var heightStr = vitals.height.height + vitals.height.units;
                            }
                            var heightDateStr = el8.service.tz.soyDate(vitals.height.recordDate);
                            heightDisplayStr = heightStr + " (" + heightDateStr + ")";
                        }
                        $contentArea.html(
                            '<p>' +
                            '  <span class="el8UnderlineText">Juvenile Wt:</span>' +
                            '  <span> ' + weightDisplayStr + '</span>' +
                            '</p>' +
                            '<p>' +
                            '  <span class="el8UnderlineText">Juvenile Ht:</span>' +
                            '  <span> ' + heightDisplayStr + '</span>' +
                            '</p>'
                        );
                    }
                ).fail(
                    function() {
                        $contentArea.html(
                            "<p><em>Failed to fetch patient vitals for display; please check your internet connection and try again.</em></p>"
                        );
                    }
                );
            }

            $(document).on('el8_noteVitalUpdate', updateVitalsDisplay);

            return updateVitalsDisplay;
        }

    };
})();
